<template>
    <div>
        <div class="title-lable-error">
            <span class="ml-3">Cannot renewal !</span>
        </div>
        <div
            class="d-flex flex-row mt-3 ml-3"
            style="color: #757575; font-size: 0.85rem"
        >
            <div>
                The machine is in the state of preparing to shut down. Cannot renewal in this state. Please wait until machine shutdown progress completed.
            </div>
        </div>
    </div>
</template>

<script>
import base from "@/scripts/base";

export default {
    extends: base,
};
</script>